import React from 'react';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const ToolbarButtonBase = React.forwardRef(function ToolbarButtonBase(props, ref) {
  const { onClick, active, classes, label, ...other } = props;
  return (
    <div className={clsx(classes.root, active && classes.active)} onClick={onClick} ref={ref} {...other}>
      <span className={classes.icon} />
      {label && <Typography className={classes.label}>{label}</Typography>}
    </div>
  );
});

export const ToolbarButton = withStyles({
  root: {
    display: 'flex',
    cursor: 'pointer',
    flexDirection: 'column',
    alignItems: 'center',
  },
  icon: ({ iconSrc }) => ({
    width: 60,
    height: 60,
    backgroundImage: `url(${iconSrc})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    display: 'inline-flex',
    transition: 'all 150ms ease-in-out',
    fill: '#0D1319',
    backgroundSize: 'contain',
  }),
  active: ({ iconSrc, activeIconSrc }) => ({
    '& > $icon': activeIconSrc
      ? {
          backgroundImage: `url(${activeIconSrc})`,
        }
      : {
          backgroundImage: `linear-gradient(#385dad, #385dad), url(${iconSrc})`,
          backgroundBlendMode: 'screen',
        },
  }),
  label: {
    fontSize: '0.9em',
  },
})(ToolbarButtonBase);
